class CartNotification extends HTMLElement {
    constructor() {
        super();

        this.notification = document.getElementById("cart-notification");
        this.wrapper = this.querySelector(".cart-notification-wrapper");
        this.countdownBar = this.notification?.querySelector(
            ".cart-notification__countdown-bar",
        );
        this.countdownDuration = 30000;
        this.countdownTimeout = null;
        this.header = document.querySelector("sticky-header");
        this.onBodyClick = this.handleBodyClick.bind(this);

        this.notification.addEventListener(
            "keyup",
            (evt) => evt.code === "Escape" && this.close(),
        );
        this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
            closeButton.addEventListener("click", this.close.bind(this)),
        );
    }

    connectedCallback() {
        if (this.moved) return;
        this.moved = true;
        document.body.appendChild(this);
    }

    open() {
        if (this.wrapper) this.wrapper.classList.add("active");
        this.notification.classList.add("animate", "active");
        this.startCountdown();

        this.notification.addEventListener(
            "transitionend",
            () => {
                this.notification.focus();
                trapFocus(this.notification);
            },
            { once: true },
        );

        document.body.addEventListener("click", this.onBodyClick);
    }

    close() {
        this.clearCountdown();
        if (this.wrapper) this.wrapper.classList.remove("active");
        this.notification.classList.remove("active");
        document.body.removeEventListener("click", this.onBodyClick);

        removeTrapFocus(this.activeElement);
    }

    startCountdown() {
        this.clearCountdown();
        if (!this.countdownBar) return;

        this.countdownBar.classList.remove("is-running");
        void this.countdownBar.offsetWidth;
        this.countdownBar.classList.add("is-running");

        this.countdownTimeout = window.setTimeout(() => {
            this.close();
        }, this.countdownDuration);
    }

    clearCountdown() {
        if (this.countdownTimeout) {
            clearTimeout(this.countdownTimeout);
            this.countdownTimeout = null;
        }
        if (this.countdownBar) {
            this.countdownBar.classList.remove("is-running");
        }
    }

    renderContents(parsedState) {
        this.cartItemKey = this.resolveNotificationKey(parsedState);
        window.lastAddedCartItemKey = this.cartItemKey || parsedState.key;
        this.getSectionsToRender().forEach((section) => {
            const sectionElement = document.getElementById(section.id);
            const sectionHTML = parsedState?.sections?.[section.id];
            if (!sectionElement || !sectionHTML) return;

            const sectionInnerHTML = this.getSectionInnerHTML(
                sectionHTML,
                section.selector,
            );
            if (sectionInnerHTML === null) return;
            sectionElement.innerHTML = sectionInnerHTML;
        });

        this.filterRenderedNotificationItems();

        // this.filterRecommendations();
        if (this.header) this.header.reveal();
        this.open();
    }

    resolveNotificationKey(parsedState) {
        const rawKey = parsedState?.key || window.lastAddedCartItemKey;
        const items = parsedState?.items;

        if (rawKey && Array.isArray(items) && items.length > 0) {
            const matchedItem = items.find((item) => item?.key === rawKey);
            if (matchedItem) {
                const props = this.getLineItemProperties(matchedItem);
                if (this.isAddonLineItem(props) && props._parent_key) {
                    return props._parent_key;
                }
                return rawKey;
            }
        }

        if (rawKey) return rawKey;

        if (Array.isArray(items) && items.length > 0) {
            const nonAddonItem = items.find((item) => {
                const props = this.getLineItemProperties(item);
                return !this.isAddonLineItem(props);
            });
            if (nonAddonItem?.key) return nonAddonItem.key;
        }

        return null;
    }

    filterRenderedNotificationItems() {
        if (!this.cartItemKey) return;
        const itemContents = this.querySelectorAll(
            "#cart-notification-product .cart-notification-product__content",
        );
        const targetId = `cart-notification-product-${this.cartItemKey}`;

        itemContents.forEach((itemContent) => {
            itemContent.style.display = itemContent.id === targetId ? "" : "none";
        });
    }

    // filterRecommendations() {
    //   if (!this.cartItemKey) return;
    //   const key = this.cartItemKey;
    //   const els = this.querySelectorAll('[data-recommendation-key]');
    //   els.forEach((el) => {
    //     el.style.display = el.dataset.recommendationKey === key ? '' : 'none';
    //   });
    //   // Force reflow so display changes apply immediately
    //   void this.offsetHeight;
    // }

    getSectionsToRender() {
        return [
            {
                id: "cart-notification-product",
                selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
            },
            {
                id: "cart-notification-button",
            },
            {
                id: "cart-icon-bubble",
            },
        ];
    }

    getSectionInnerHTML(html, selector = ".shopify-section") {
        const parsed = new DOMParser().parseFromString(html, "text/html");
        const matchedElement = selector
            ? parsed.querySelector(selector)
            : parsed.querySelector(".shopify-section");
        return matchedElement ? matchedElement.innerHTML : null;
    }

    getLineItemProperties(item) {
        const raw = item?.properties;
        if (!raw) return {};
        if (Array.isArray(raw)) {
            return raw.reduce((acc, pair) => {
                if (pair && pair.name != null) acc[String(pair.name)] = pair.value;
                return acc;
            }, {});
        }
        return raw;
    }

    isAddonLineItem(properties) {
        return (
            properties?._is_protection === "true" ||
            properties?._is_extra_item === "true" ||
            properties?._is_extra_item_protection === "true"
        );
    }

    handleBodyClick(evt) {
        const target = evt.target;
        if (
            target !== this.notification &&
            !target.closest("cart-notification")
        ) {
            const disclosure = target.closest(
                "details-disclosure, header-menu",
            );
            this.activeElement = disclosure
                ? disclosure.querySelector("summary")
                : null;
            this.close();
        }
    }

    setActiveElement(element) {
        this.activeElement = element;
    }
}

customElements.define("cart-notification", CartNotification);
